import { MarketContextManager } from '@market/react';
import React, { FC, createContext, ReactNode, useCallback, useContext, useRef } from 'react';

interface MarketContext {
  getContextManager: () => globalThis.HTMLMarketContextManagerElement | null;
}

interface MarketContextProviderProps {
  children: ReactNode;
}

const Context = createContext<MarketContext>({
  getContextManager: () => null,
});

/*
  A nice component that creates the MarketContextManager for you,
  and puts it in a shared context.
 */
export const MarketContextProvider: FC<React.PropsWithChildren<MarketContextProviderProps>> = ({ children }) => {
  const contextManagerRef = useRef<globalThis.HTMLMarketContextManagerElement>(null);

  const getContextManager = useCallback(() => {
    return contextManagerRef.current;
  }, []);

  return (
    <>
      <MarketContextManager ref={contextManagerRef} />
      <Context.Provider value={{ getContextManager }}>{children}</Context.Provider>
    </>
  );
};

export const useMarketContext = (): MarketContext => useContext(Context);
